// The scanner's heavy parts — the neural network runtime and the two models, about 24 MB between
// them — are fetched the first time somebody scans and not before. A clerk who admits trucks by
// typing never downloads them, and they are not in the app's own bundle at all.

const ASSETS = `${process.env.PUBLIC_URL || ''}/static/scan`;
// These files are served with a year's cache and never revalidated, which is what makes the second
// scan instant. A replaced model therefore needs this bumped, or browsers keep the one they hold.
const VERSION = '1';

const once = (load) => {
  let started = null;
  return () => { started = started || load(); return started; };
};

const script = (src) => new Promise((resolve, reject) => {
  const tag = document.createElement('script');
  tag.src = src;
  tag.async = true;
  tag.onload = () => resolve();
  // Naming the file matters more than it looks. This same failure covers a dropped connection, a
  // blocked request and a browser still running an older build that is asking for a file the
  // current release no longer ships - and only the name tells those three apart.
  // Naming the file matters more than it looks. One message covers a dropped connection, a blocked
  // request, and a browser still running an older build that is asking for a file the current
  // release no longer ships — and only the file name tells those three apart.
  tag.onerror = () => reject(new Error(`The scanner could not be downloaded (${src.split('/').pop().split('?')[0]}). Reload the page and try again — if it persists, check the connection.`));
  document.head.appendChild(tag);
});

export const onnx = once(async () => {
  await script(`${ASSETS}/ort.min.js?v=${VERSION}`);
  const { ort } = window;
  ort.env.wasm.wasmPaths = `${ASSETS}/`;
  // Threads would need cross-origin isolation, and turning that on would cut off Google Maps and
  // Google sign-in, which are worth more than the seconds it would save here.
  ort.env.wasm.numThreads = 1;
  ort.env.logLevel = 'error';
  return ort;
});

export const asset = (name) => `${ASSETS}/${name}?v=${VERSION}`;
